// DEPLOY: /var/www/woody.wtf/frontend/src/chart/timeframes.js
// woody.wtf chart engine: build longer candles from base candles in the browser. Period candle =
// first open, highest high, lowest low, last close, summed volume; its time (and New York day /
// minute fields on intraday) is the first base candle of the period.
// Daily family (W/M/6M/Y) is built from daily candles; intraday (5m-4h) from 1-minute candles,
// buckets counted from New York midnight so they start on the hour from 04:00 (4h: 04/08/12/16).
const DAY = 86400000;

export const TIMEFRAMES = [
  { id: '1m',  label: '1m', group: 'Minutes', min: 1 },
  { id: '5m',  label: '5m', group: 'Minutes', min: 5 },
  { id: '15m', label: '15m', group: 'Minutes', min: 15 },
  { id: '30m', label: '30m', group: 'Minutes', min: 30 },
  { id: '1h',  label: '1h', group: 'Hours', min: 60 },
  { id: '2h',  label: '2h', group: 'Hours', min: 120 },
  { id: '4h',  label: '4h', group: 'Hours', min: 240 },
  { id: '1D',  label: 'D', group: 'Days' },
  { id: '1W',  label: 'W', group: 'Days' },
  { id: '1M',  label: 'M', group: 'Days' },
  { id: '6M',  label: '6M', group: 'Days' },
  { id: '12M', label: 'Y', group: 'Days' },
];
export const TF_GROUPS = ['Minutes', 'Hours', 'Days'];
export const DEFAULT_FAV_TF = ['5m', '1h', '1D', '1W', '1M'];
export const tfInfo = id => TIMEFRAMES.find(t => t.id === id) || TIMEFRAMES[7];
export const isIntraday = id => !!tfInfo(id).min;

// Period key per timeframe (UTC, so the server's date timestamps bucket exactly).
const KEY = {
  '1W':  t => { const d = new Date(t); return Math.floor((t - ((d.getUTCDay() + 6) % 7) * DAY) / DAY); },  // Monday of the week
  '1M':  t => { const d = new Date(t); return d.getUTCFullYear() * 12 + d.getUTCMonth(); },
  '6M':  t => { const d = new Date(t); return d.getUTCFullYear() * 2 + (d.getUTCMonth() >= 6 ? 1 : 0); },
  '12M': t => new Date(t).getUTCFullYear(),
};

export function aggregate(bars, tf) {
  const m = tfInfo(tf).min;
  const key = m ? (m > 1 ? b => `${b.day}|${Math.floor(b.min / m)}` : null) : KEY[tf];
  if (!key) return bars;
  const out = [];
  let cur = null, curKey = null;
  for (const b of bars) {
    const k = m ? key(b) : key(b.t);
    if (k !== curKey) {
      cur = { ...b, v: b.v || 0 };
      out.push(cur); curKey = k;
    } else {
      if (b.h > cur.h) cur.h = b.h;
      if (b.l < cur.l) cur.l = b.l;
      cur.c = b.c;
      cur.v += b.v || 0;
      if (b.live) cur.live = b.live;          // a period holding today's unconfirmed candle is purple too
      if (b.sess === 'reg') cur.sess = 'reg';   // a bar holding any regular-session minute isn't shaded
    }
  }
  return out;
}
